import React, { memo } from 'react';
import { compose, pipe, values, when, complement, isNil } from 'ramda';
import { useTranslation } from 'react-i18next';
import useEmblaCarousel from 'embla-carousel-react';

import { useCurrentWidth, useFetchData } from 'effects';
import { mapWithIndex } from 'utils';

import Offer from 'containers/OfferPromo';

import connect from './LatestOffers.state';
import { Title, Offers } from './LatestOffers.styles';
import { Loader } from 'components/Loader/Loader';

const renderOffer = (offer, i) => <Offer key={i} id={offer} />;

const renderOffers = when(complement(isNil), pipe(mapWithIndex(renderOffer), values));

export const LatestOffers = ({ fetchLatestOffers, offers, offersStatus }) => {
  const { t } = useTranslation();
  const offersFetched = useFetchData(offersStatus, fetchLatestOffers, []);
  const [emblaRef] = useEmblaCarousel({ loop: true });

  const { isMobile } = useCurrentWidth();

  return (
    <div className="container mx-auto max-w-1280px p-0">
      {offers.length ? <Title>{t('sections.latestOffers')}</Title> : null}
      <Loader isLoading={!offersFetched}>
        <div>
          {!isMobile && <div className="flex flex-wrap justify-center">{renderOffers(offers)}</div>}
          {isMobile && (
            <div ref={emblaRef} className="overflow-hidden">
              <div className="flex">
                {renderOffers(offers)?.map((offer, i) => (
                  <div key={i} className="min-w-0 flex-[0_0_100%] bg-white">
                    {offer}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Loader>
    </div>
  );
};

export default compose(connect, memo)(LatestOffers);
